import * as React from "react";
import { ButtonGroup } from 'react-bootstrap';
import { Link, useLocation } from "react-router-dom";
import AddToStudying from './AddToStudying';
import ExternalLinks from './ExternalLinks';
import { Card, DictionaryPaths, UserMode } from '../../types/Common';

export default function CardPanel(props: { card: Card, userMode: UserMode, dictionaryPaths: DictionaryPaths }) {
    const { state, pathname } = useLocation();
    const userMode = props.userMode ?? (state ? state as UserMode : undefined);
    const { dictionaryId, dictionaryName } = userMode;

    return (
        <div>
            <ButtonGroup className="d-block">
                <Link className="btn px-2 btn-outline-primary"
                    to={`/dictionaries/${dictionaryId}`}>
                    {dictionaryName}</Link>

                <Link className={"btn px-2 " + (pathname.indexOf('/cards/') >= 0 && pathname.indexOf('/similar') === -1 && pathname.indexOf('/results') === -1 ? "btn-primary" : "btn-outline-primary")}
                    to={`/cards/${props.card.id}`}
                    state={userMode}>
                    Card</Link>

                <Link className={"btn px-2 " + (pathname.indexOf('/similar') >= 0 ? "btn-primary" : "btn-outline-primary")}
                    to={`/cards/${props.card.id}/similar`}
                    state={userMode}>
                    Similar</Link>

                <Link className={"btn px-2 " + (pathname.indexOf('/results') >= 0 ? "btn-primary" : "btn-outline-primary")}
                    to={`/cards/${props.card.id}/results`}
                    state={userMode}>
                    Results</Link>

            </ButtonGroup>

            <div className="panel mt-2 mb-0">
                {props.dictionaryPaths.phraseLanguageCode &&
                    <ExternalLinks card={props.card}
                        dictionaryPaths={props.dictionaryPaths} />
                }

                <AddToStudying
                    cardId={props.card.id}
                    isDirect={props.userMode.isDirect}
                    disabled={false} />
            </div>
        </div >
    )
}
